import styled from "styled-components";

export const Wrapper = styled.div`
  max-width: 1920px;
  width: 90vw;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
